export default __webpack_public_path__ + "e10c6cfe7bb774396a69f688f57a18b6.png";